import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D276 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D276 - Web Development Foundations</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 11.27 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            For this course, I thoroughly completed chapters 1-6 and worked
            through a bit of chapter 7. The zybooks material is really good for
            this course. However, the CSS content is so extensive, and there’s
            so much to cover that it’s almost impossible to remember everything.
            Frontend development, however, doesn’t interest me as much, and I
            feel that CSS is something that should be learned along the way. I
            did use W3Schools for CSS, which was a bit easier to grasp than the
            zybooks material.
          </p>
          <p>
            Make sure to complete all the D276 practice quizzes on
            myquizzets.com, as many questions from the OA Simulation quiz
            appeared there. There are a lot of Reddit posts for this course, but
            I feel like most of them encourage overstudying. You can only cram
            so much CSS into one course. Focus on understanding the foundations,
            like basic selectors, advanced selectors, box models, and
            positioning elements (especially z-index). The box model took me a
            while to understand. Additionally, make sure you know how CSS
            precedence works (for example, inline styling overrides other CSS
            written elsewhere).
          </p>
          <p>
            For HTML, know the structure of an HTTP request, the types of
            requests, and how a web browser and web server communicate through
            requests. I took the PA and passed the sections, but I wasn’t
            entirely sure I’d pass the OA. I took it anyway, and it turned out
            to be a bit easier than the PA and similar to the myquizzets
            quizzes. Honestly, if you do the myquizzets quizzes and go through
            zybooks, I’d recommend scheduling the OA. If you fail, you can try
            again, but it’s not that hard.
          </p>
          <p>Notes I made for this course can be downloaded here: <a href="/D276 - Web Development.docx" download="D276 - Web Development.docx">Download Notes</a></p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D276;
